export default "__VITE_ASSET__5ee3b190__"